import sanitize from 'sanitize-html';

export function sanitizeRichText(html: string): string {
    return sanitize(html, {
        allowedTags: sanitize.defaults.allowedTags,
        allowedAttributes: sanitize.defaults.allowedAttributes,
    });
}
